import { SearchCategoryModalHandler } from "./search-category-modal-handler";
import { SearchCategoryModalListener } from "./search-category-modal-listener";
import { CategoryReviewEditorSetup } from "./edit/category-review-editor-setup";
import { searchCategoryModalForm } from "./search-category-modal-form";

const handlersByOverlay = new WeakMap<HTMLElement, SearchCategoryModalHandler>();

export class SearchCategoryModalSetup {
    public static init(rootEl: Document | HTMLElement = document): SearchCategoryModalHandler | null {
        const overlayEl = searchCategoryModalForm.getOverlay(rootEl);
        const modalEl = searchCategoryModalForm.getModal(rootEl);
        const listEl = searchCategoryModalForm.getList(rootEl);
        const filterInputEl = searchCategoryModalForm.getFilterInput(rootEl);
        const showAllToggleEl = searchCategoryModalForm.getShowAllToggle(rootEl);
        const closeBtnEl = searchCategoryModalForm.getCloseButton(rootEl);

        if (
            !(overlayEl instanceof HTMLElement) ||
            !(modalEl instanceof HTMLElement) ||
            !(listEl instanceof HTMLElement)
        ) {
            return null;
        }

        SearchCategoryModalListener.bindDataUpdatedRefresh({
            getHandler: () => SearchCategoryModalSetup.init(document),
        });

        const existing = handlersByOverlay.get(overlayEl);
        if (existing) return existing;

        CategoryReviewEditorSetup.init(rootEl);

        const handler = new SearchCategoryModalHandler({
            overlayEl,
            modalEl,
            listEl,
            filterInputEl,
            showAllToggleEl,
        });

        SearchCategoryModalListener.setup({
            rootEl,
            overlayEl,
            modalEl,
            closeBtnEl,
            listEl,
            filterInputEl,
            handler,
        });

        handlersByOverlay.set(overlayEl, handler);
        return handler;
    }
}
